import Section from './Section';
import SectionHeader from './SectionHeader';
import { Text, Heading, Button } from '@chakra-ui/react';
import { ArrowCircleRight } from './sharedCode/components/UiElements';
import Link from 'next/link';

const posts = [
    {
        title: 'Tab Fix: How to fix the problem of too many open tabs once and for all.',
        description:
            'If you work or study online, you often know how stressful it is to deal with a browser full of tabs: research, projects, emails, to-do lists… all competing for your attention. Sooner than later, the tab clutter becomes overwhelming, slowing you down and affecting your focus.',
        coverImage: '/blog/blog_01_tab_fix_01.webp',
        slug: 'tab-fix',
        date: '2024-12-25'
    },
    {
        title: 'Five Tools for productivity in your browser',
        description:
            'For anyone spending hours working in a browser, the struggle of managing tabs, bookmarks, and daily tasks with efficiency is very real. Overloaded browsers slow you down, distractions pile up, and crucial information gets lost in the shuffle.',
        coverImage: '/blog/b2/blog_02_00.png',
        slug: 'five-tools-for-productivity-in-your-browser',
        date: '2025-01-29'
    },
    {
        title: 'How to organize multiple projects to increase productivity',
        description:
            'Discover three simple strategies for project organization and managing multiple projects efficiently. Learn how to streamline business processes, stay focused, and use organizational tools to enhance your workflow.',
        coverImage: '/blog/b3/b3_00.webp',
        slug: 'organize-multiple-projects',
        date: '2025-02-12'
    }
];

const BlogSection = () => {
    return (
        <Section
            id="pricing"
            color="white"
            size="small"
            backgroundImage=""
            backgroundImageOpacity={1}
        >
            <div className="container">
                <SectionHeader
                    title={'The productivity tab'}
                    subtitle={'Tips on making your browser work better for you'}
                    size={1}
                    spaced={true}
                    className="has-text-centered"
                />
                {/* Featured Post */}
                <div className="columns is-centered mb-6">
                    <div className="column is-8">
                        <div
                            className="card"
                            style={{ borderRadius: '12px', overflow: 'hidden' }}
                        >
                            <div className="card-image">
                                <figure className="image is-16by9">
                                    <img
                                        src={posts[posts.length - 1].coverImage}
                                        alt={posts[posts.length - 1].title}
                                    />
                                </figure>
                            </div>
                            <div className="card-content">
                                <Text fontSize="sm" color="gray.500" mb={1}>
                                    {posts[posts.length - 1].date}
                                </Text>
                                <Heading as="h2" fontSize="2xl" mb={2}>
                                    {posts[posts.length - 1].title}
                                </Heading>
                                <Text fontSize="md" color="gray.600">
                                    {posts[posts.length - 1].description}
                                </Text>
                                <Link
                                    href={`/blog/${
                                        posts[posts.length - 1].slug
                                    }`}
                                >
                                    <Button
                                        variant="outline"
                                        colorScheme="gray"
                                        color="gray.800"
                                        size="sm"
                                        mt={5}
                                        border="1px solid var(--chakra-colors-gray-200)"
                                    >
                                        Read on →
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Regular Posts */}
                <div className="columns is-centered">
                    {posts.slice(0, -1).map((post, index) => (
                        <div className="column is-4" key={index}>
                            <div
                                className="card"
                                style={{
                                    borderRadius: '12px',
                                    overflow: 'hidden'
                                }}
                            >
                                <div className="card-image">
                                    <figure className="image is-16by9">
                                        <img
                                            src={post.coverImage}
                                            alt={post.title}
                                        />
                                    </figure>
                                </div>
                                <div className="card-content">
                                    <Text fontSize="sm" color="gray.500" mb={1}>
                                        {post.date}
                                    </Text>
                                    <Heading as="h2" fontSize="xl" mb={2}>
                                        {post.title}
                                    </Heading>
                                    <Text fontSize="sm" color="gray.600">
                                        {post.description}
                                    </Text>
                                    <Link href={`/blog/${post.slug}`}>
                                        <Button
                                            variant="outline"
                                            colorScheme="gray"
                                            size="sm"
                                            mt={5}
                                            color="GrayText"
                                            border="1px solid var(--chakra-colors-gray-200)"
                                        >
                                            Read on →
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
};

export default BlogSection;
